export default {
    characters: "characters",
    choice: "choice",
    chooseCountry: "Choose country",
    city: "City",
    courseSelection: "course",
    draftEmailButtonCancel: "Cancel",
    draftEmailButtonSend: "Send",
    draftEmailHeadline: "Enter your email",
    draftEmailText: "Enter your email to get a link you can use to complete the application later.",
    draftErrorSubmitted: "The application has already been submitted.",
    errorNoOpenCourses: "Currently, the school doesn't have any available courses.",
    errorNoOpenCoursesHeadline: "No available courses",
    formButtonAddCourse: "Optionally add more choices here",
    formButtonSaveDraft: "Save draft",
    formButtonSubmit: "Submit application",
    formChooseFile: "Choose file",
    formDefaultOptionCourse: "Course",
    formDefaultOptionCourse2: "Course",
    formDefaultOptionCoursePlus: "Project course",
    formDraftUrlLink: "Get link on e-mail",
    formDraftUrlText: "If you want to continue your application later?",
    formErrorCourse: "You must select a course.",
    formErrorDate: "Invalid date.",
    formErrorEmail: "Invalid email.",
    formErrorPhone: "invalid phone number.",
    formErrorRequired: "Please enter",
    formErrorRequiredAlternative: "Please select at least one alternative.",
    formErrorRequiredCountry: "Please choose a country.",
    formErrorRequiredDate: "Please select date.",
    formErrorRequiredFile: "Please upload a file.",
    formErrorRequiredGeneric: "This field is required.",
    formErrorRequiredSocialSecurity: "Please enter your social security number",
    formErrorRequiredZip: "Please enter a zipcode.",
    formErrorSocialSecNr: "Invalid social security number.",
    formErrorZip: "Invalid zip code.",
    formExplanationApply: "The application is completely non-binding, and you can decline the offer if you change your mind.",
    formExplanationCourse: "Are there any more lines you would like to apply to at this school?",
    formExplanationSoonFinished: "You are almost done! Check the application before submitting.",
    formHeadline: "What kind of course do you want to apply to?",
    formHeadlineCourse: "Which course do you want to apply to?",
    formHeadlineCourse2: "Which additional course do you want to apply to?",
    formHeadlineCoursePlus: "Which project course do you want to apply for?",
    formHeadlineSummary: 'Check stored information and press "send"',
    formHeadlineSummaryCoursePlus: "Project courses",
    formHeadlineSummaryCourses: "Courses",
    formHeadlineSummarySchool: "School",
    formIntroRequired: "Fields marked with <span>*</span> are required",
    formMessageSubmittedSuccess: "The application is submitted!",
    formNorwegianCitizen: "Norway",
    formOtherCitizen: "Other",
    formPageNext: "Next",
    formPageNextHint: "Soon done! Proceed and check the application before submitting.",
    formPagePrevious: "Back",
    formRecieptText: "Print application receipt",
    formSubmitHeadline: "Submit application:",
    formSubmitIntro: 'Press "Send" to submit your application.',
    formSubmitSuccessHeadline: "Application submitted!",
    formSubmitSuccessText: "Thank you for your application. The school will contact you shortly.",
    formSubmittingText: "Sending application",
    max: "Max",
    no: "No",
    optional: "optional",
    phoneNumber: "Phone number",
    readMoreAboutSchool: "Read more about the school",
    yes: "Yes",
    zipcode: "Postcode",
};